import { useState, useEffect } from "react";

export function useSettingsTabs() {
    const [tabs, setTabs] = useState([]);

    useEffect(() => {
    fetch("/mock-data/mock_settingsTabs.json")
        .then((res) => res.json())
        .then((data) => setTabs(data));
    }, []);

    return tabs;
}